import { useState } from 'react';
import { Col, Divider, Drawer, Form, Input, message, Row, Space, Typography } from 'antd';
import { drawerWidth, formItemLayout, notifyMessages } from '../../utils/constants';
import { DrawerFormButtons } from '../../components/common/drawersFormButtons';
import UsersServices from '../../services/usersServices';

const { Text } = Typography

const ResetUserPassword = ({ open, onClose, recordData }) => {
    const [form] = Form.useForm();
    const [loadingButton, setLoadingButton] = useState(false);

    const saveData = async (values) => {
        let payload = {
            userID: values.id,
            newPassword: values.password
        }

        setLoadingButton(true);
        try {
            const respData = await UsersServices.resetUserPassword(payload);

            if (respData.success) {
                message.success(notifyMessages.success);
                setLoadingButton(false);
                onClose();
                form.resetFields();
            }
            else {
                message.error(notifyMessages.errorAccured);
                setLoadingButton(false);
            }

        } catch (error) {
            message.error(notifyMessages.errorAccured);
            setLoadingButton(false);
        }
    }

    const onCloseAction = () => {
        onClose();
        form.resetFields();
    }

    return (
        <Drawer
            title="Cambia password"
            width={drawerWidth}
            onClose={onCloseAction}
            destroyOnClose={true}
            open={open}
            extra={
                <DrawerFormButtons disabled={false} close={onCloseAction} loadingButton={loadingButton} formId={"newUser"} />
            }
        >
            <Form
                id="newUser"
                form={form}
                layout="vertical"
                {...formItemLayout}
                autoComplete="off"
                onFinish={(values) => saveData(values)}
            >
                <Row gutter={16}>

                    <Form.Item name="id" initialValue={recordData.id} hidden={true}></Form.Item>

                    <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }}>
                        <Form.Item
                            label="Username"
                            name="username"
                            rules={[{ required: true, message: notifyMessages.requiredField }]}
                            initialValue={recordData.username}
                            disabled
                        >
                            <Input disabled />
                        </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: notifyMessages.requiredField
                                },
                                () => ({
                                    validator(_, value) {
                                        if (!value) {
                                            return Promise.reject(new Error('Conferma la password!'));
                                        }
                                        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/;
                                        if (!regex.test(value)) {
                                            return Promise.reject(
                                                new Error('Password deve essere lunga almeno 8 caratteri e contenere una lettera maiuscola, una minuscola e un numero.')
                                            );
                                        }
                                        return Promise.resolve();
                                    },
                                }),
                            ]}
                        >
                            <Input.Password autoComplete='off' />
                        </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Form.Item
                            label="Conferma Password"
                            name="password2"
                            dependencies={['password']}
                            rules={[
                                {
                                    required: true,
                                    message: notifyMessages.requiredField
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value) {
                                            return Promise.reject(new Error('Conferma la password!'));
                                        }

                                        if (getFieldValue('password') !== value) {
                                            return Promise.reject(new Error('Password inserita non corrisponde'));
                                        }

                                        return Promise.resolve();
                                    },
                                }),
                            ]}
                        >
                            <Input.Password autoComplete='off' />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>

            <Divider />

            <Row gutter={16}>
                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 24 }} lg={{ span: 24 }}>
                    <Space direction='vertical'>
                        <Text italic>* Password deve essere lunga almeno 8 caratteri.</Text>
                        <Text italic>* Password deve contenere una lettera maiuscola.</Text>
                        <Text italic>* Password deve contenere una lettera minuscola.</Text>
                        <Text italic>* Password deve contenere un numero.</Text>
                    </Space>
                </Col>
            </Row>
        </Drawer>
    );
}
export default ResetUserPassword;